import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  /** Ein Satz, der die Seite erklaert. */
  description?: ReactNode;
  /** Knoepfe rechts. */
  actions?: ReactNode;
  /** Info-Knopf neben der Ueberschrift. */
  info?: ReactNode;
}

/**
 * Seitenkopf.
 *
 * Traegt das einzige h1 der Seite. Die Beschreibung ist kein Beiwerk: sie ist
 * fuer viele Nutzer die einzige Stelle, an der steht, wozu diese Seite gut
 * ist. Deshalb steht sie hier und nicht in einem aufklappbaren Hilfetext.
 */
export function PageHeader({ title, description, actions, info }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header__text">
        <div className="page-header__title-row">
          <h1 className="page-header__title">{title}</h1>
          {info}
        </div>
        {description && <p className="page-header__description">{description}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
